import Swal from 'sweetalert2'

export default {

    ShowMessage(message,title) {
        this.ShowMessage_private(message,title,false);
    },
    ShowMessageThenRefresh(message,title) {
        this.ShowMessage_private(message,title,true);
    },
    ShowMessage_private(message,title,refresh){
        if (title===undefined){
            title="Message"
        }

        Swal.fire({
            html: message,
            showCloseButton: true,
            button: "OK!",
            closeButtonHtml: '',
            focusConfirm: false,
            reverseButtons: false,
            allowOutsideClick: true,
            showClass: {
                popup: 'animate__animated animate__fadeIn'
            },
            hideClass: {
                popup: 'animate__animated animate__fadeOut'
            },
            customClass: {
                container: 'custom-sweetAlert',
            }
        }).then((result) => {
            if (refresh){
                if (result.isConfirmed) {
                    // 使用者按下 OK 按鈕後刷新網頁
                    window.location.reload();
                }
            }
        });
    },
}
